"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _EventEmitter_events, _WithEventEmitter_eventEmitter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithEventEmitter = void 0;
class EventEmitter {
    constructor() {
        _EventEmitter_events.set(this, {});
    }
    emit(eventKey, ...args) {
        const events = Array.isArray(eventKey) ? eventKey : [eventKey];
        events.forEach((event) => {
            var _a;
            if (!__classPrivateFieldGet(this, _EventEmitter_events, "f")[event])
                return;
            const handlers = (_a = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _a !== void 0 ? _a : [];
            handlers.forEach((handler) => handler(...args));
        });
    }
    on(eventKey, handler) {
        const events = Array.isArray(eventKey) ? eventKey : [eventKey];
        events.forEach((event) => {
            var _a, _b;
            __classPrivateFieldGet(this, _EventEmitter_events, "f")[event] = (_a = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _a !== void 0 ? _a : [];
            const handlers = (_b = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _b !== void 0 ? _b : [];
            handlers.push(handler);
        });
        return () => this.off(eventKey, handler);
    }
    off(eventKey, handler) {
        const events = Array.isArray(eventKey) ? eventKey : eventKey ? [eventKey] : Object.keys(__classPrivateFieldGet(this, _EventEmitter_events, "f"));
        events.forEach((event) => {
            var _a, _b;
            __classPrivateFieldGet(this, _EventEmitter_events, "f")[event] = (_a = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _a !== void 0 ? _a : [];
            const handlers = (_b = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _b !== void 0 ? _b : [];
            const index = handlers.findIndex((filterHandler) => handler === undefined || handler === filterHandler);
            __classPrivateFieldGet(this, _EventEmitter_events, "f")[event] = handlers.filter((handler, filterIndex) => index !== filterIndex);
        });
    }
    getHandlers(eventKey) {
        const events = Array.isArray(eventKey) ? eventKey : [eventKey];
        return events.reduce((handlers, event) => {
            var _a;
            return [
                ...handlers,
                ...((_a = __classPrivateFieldGet(this, _EventEmitter_events, "f")[event]) !== null && _a !== void 0 ? _a : []),
            ];
        }, []);
    }
}
exports.default = EventEmitter;
_EventEmitter_events = new WeakMap();
class WithEventEmitter {
    constructor() {
        _WithEventEmitter_eventEmitter.set(this, void 0);
        __classPrivateFieldSet(this, _WithEventEmitter_eventEmitter, new EventEmitter(), "f");
    }
    on(...args) {
        // @ts-ignore
        return __classPrivateFieldGet(this, _WithEventEmitter_eventEmitter, "f").on(...args);
    }
    emit(...args) {
        // @ts-ignore
        return __classPrivateFieldGet(this, _WithEventEmitter_eventEmitter, "f").emit(...args);
    }
    off(...args) {
        // @ts-ignore
        return __classPrivateFieldGet(this, _WithEventEmitter_eventEmitter, "f").off(...args);
    }
}
exports.WithEventEmitter = WithEventEmitter;
_WithEventEmitter_eventEmitter = new WeakMap();
